export const Permissions = {
  VIEW_CHANNELS:      1 << 0,
  MANAGE_CHANNELS:    1 << 1,
  MANAGE_ROLES:       1 << 2,
  VIEW_SERVER_LOGS:   1 << 3,
  MANAGE_WEBHOOKS:    1 << 4,
  MANAGE_SERVER:      1 << 5,
  CREATE_INVITE:      1 << 6,
  KICK_MEMBERS:       1 << 7,
  BAN_MEMBERS:        1 << 8,
  SEND_MESSAGES:      1 << 9,
  ATTACH_FILES:       1 << 10,
  ADD_REACTIONS:      1 << 11,
  MANAGE_MESSAGES:    1 << 12,
  CONNECT_VOICE:      1 << 13,
  ADMINISTRATOR:      1 << 14,
} as const;

export const ALL_PERMISSIONS = Object.values(Permissions).reduce((acc, bit) => acc | bit, 0);

/**
 * Compute effective permissions by OR-ing all assigned role permission bitfields.
 * Owner gets all permissions.
 */
export function computeEffectivePermissions(
  isOwner: boolean,
  roles: { permissions: number }[],
): number {
  if (isOwner) return ALL_PERMISSIONS;
  let effective = 0;
  for (const role of roles) {
    effective |= (role.permissions ?? 0);
  }
  if (effective & Permissions.ADMINISTRATOR) return ALL_PERMISSIONS;
  return effective;
}

export function hasPermission(effective: number, flag: number): boolean {
  return (effective & flag) === flag;
}
